export const CHECKOUT_URL = 'https://colorpack.store/cart/53653671379258:1' // Link de pago (checkout)
